var _defs, _path, _polyline, _path2, _path3, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoicesSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256.02 256.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#06183d;}.b{fill:#fefefe;}.c{fill:#cccccc;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M128.19,0C198.12-.33,256,56.34,256,128c0,70-56.25,129.33-130.9,128A127.79,127.79,0,0,1,0,125.26C1.15,57.06,57-.44,128.19,0Z",
    transform: "translate(0.02 0)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "184.35 27.34 184.35 172.07 94.45 230.51 95.35 72.29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M160.79,177.79l-3.47,1.47a24.91,24.91,0,0,1-6,1.63c-1.38.21-1.55,0-1.3-1.31.47-2.5,1-5,1.4-7.51.11-.68.29-1,1-1a21.2,21.2,0,0,0,8.13-2c3.16-1.57,6-3.45,7.51-6.87a5.61,5.61,0,0,0,.21-3.48c-.27-1.19-1.37-1.45-2.43-1.54a16,16,0,0,0-4.2.36c-2.62.47-5.25.93-7.89,0a5.37,5.37,0,0,1-3.49-3.8c-1-3.34-.3-6.58.87-9.72a28.29,28.29,0,0,1,8.52-12,2.35,2.35,0,0,0,.95-2.06c-.08-1.79,0-3.59,0-5.38,0-.43,0-.8.47-1.06,1.86-1,3.71-2.13,5.55-3.21.61-.37.86-.27.85.5v4.81c0,.76.06,1,.91.62a22.69,22.69,0,0,1,6.79-2.29c1.4-.2,1.55-.11,1.29,1.23-.47,2.5-1,5-1.41,7.51a.91.91,0,0,1-1,.83,18.87,18.87,0,0,0-11.45,4.89,7.56,7.56,0,0,0-2.6,5c-.16,1.4,1,2.47,2.78,2.5a31.74,31.74,0,0,0,5.67-.53,11.9,11.9,0,0,1,6.4.33,5.59,5.59,0,0,1,3.44,4.77c.93,6.09-1,11.43-4.47,16.32a29.58,29.58,0,0,1-5.85,6.08,2.19,2.19,0,0,0-1,2c.08,1.64,0,3.29,0,4.93a1.32,1.32,0,0,1-.75,1.38c-1.51.81-3,1.65-4.46,2.57-1,.62-1,.18-1-.65C160.82,181.35,160.79,179.64,160.79,177.79Z",
    transform: "translate(0.02 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M160.35,39.36l1.61-.79c.1,2.4.31,4.79.2,7.19a1,1,0,0,0,.58,1.12,1.16,1.16,0,0,0,1.28-.2,2.62,2.62,0,0,0,.9-2.35V37.12l1.8-.92c0,2.71.09,5.41,0,8.11a6.52,6.52,0,0,1-2,4.7,2.7,2.7,0,0,1-3.06.55c-1.08-.4-1.28-1.32-1.28-2.32C160.34,44.61,160.35,42,160.35,39.36Z",
    transform: "translate(0.02 0)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "89.02 69 95.32 72.3 184.32 27.3 178.02 26 89.02 69"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "102.02 79 102.02 84 123.02 73 123.02 68 102.02 79"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "102.02 99.42 102.02 104.42 180.02 63 180.02 58 102.02 99.42"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "102.02 109.65 102.02 114.65 180.02 73.22 180.02 68.22 102.02 109.65"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "102.02 120.65 102.02 125.65 180.02 83.22 180.02 78.22 102.02 120.65"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "102.02 131.16 102.02 136.16 180.02 93.73 180.02 88.73 102.02 131.16"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "102.02 141.16 102.02 146.16 180.02 103.73 180.02 98.73 102.02 141.16"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "102.02 152.16 102.02 157.16 146.02 133 146.02 128 102.02 152.16"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "102.02 162.79 102.02 167.79 146.02 143.63 146.02 138.63 102.02 162.79"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "102.02 173.79 102.02 178.79 146.02 153.63 146.02 148.63 102.02 173.79"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "102.02 195.08 102.02 200.08 129.02 184 129.02 179 102.02 195.08"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "102.02 203.54 102.02 208.54 121.02 197 121.02 192 102.02 203.54"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "70.02 224 89.02 214 89.02 225 94.02 230 70.02 224"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicesSelected);
export default __webpack_public_path__ + "static/media/invoices_selected.039ba2b8b257ce62b58ea877b8b1eae2.svg";
export { ForwardRef as ReactComponent };